export enum OrganizationPropertyName {
	PUSH_MODULE_COACHEE_ANSWERS_ACCESS_ENABLED = 'PUSH_MODULE_COACHEE_ANSWERS_ACCESS_ENABLED',
	MODULE_AVERAGE_DURATION_DISPLAY_ENABLED = 'MODULE_AVERAGE_DURATION_DISPLAY_ENABLED',
	MODULE_LIBRARY_COACHEE_ACCESS_ENABLED = 'MODULE_LIBRARY_COACHEE_ACCESS_ENABLED',
	PUSH_MODULE_COACHEE_RESEND_ENABLED = 'PUSH_MODULE_COACHEE_RESEND_ENABLED',
	COACHING_BOOTH_MEETING_ENABLED = 'COACHING_BOOTH_MEETING_ENABLED',
	ON_BOARDING_WITH_COACH_ENABLED = 'ON_BOARDING_WITH_COACH_ENABLED',
	COACH_DISSOCIATION_ENABLED = 'COACH_DISSOCIATION_ENABLED',
	IS_SUBSCRIPTION_OPTIONAL = 'IS_SUBSCRIPTION_OPTIONAL',
	COACH_ADD_USER_ENABLED = 'COACH_ADD_USER_ENABLED',
	COACHING_BOOTH_ENABLED = 'COACHING_BOOTH_ENABLED',
	AI_GENERATION_ENABLED = 'AI_GENERATION_ENABLED',
	COACHEE_LIMIT = 'COACHEE_LIMIT',
	IS_FICTITIOUS = 'IS_FICTITIOUS',
}
